export enum TagStatus {
    Active = 1,
    Deactivated = 2,
    Draft = 3,
    Deleted = 4
}
